// This hook manages the gap after last element in a looped carousel, that uses column-gap property

import { useEffect, useRef } from 'react';
import { getCarouselState } from '../utils';

export const useHandleGapInLoop = (emblaApi, ref) => {
  const isHandledGapInLoop = useRef(false);
  const listNode = ref.current;
  const { loop, hasEndingLoopGap, hasItemsToScroll } = getCarouselState(emblaApi);

  const applyEndingLoopGap = () => {
    try {
      if (!listNode) {
        return;
      }

      const style = window.getComputedStyle(listNode);
      const listColumnGap = style.columnGap;

      if (listColumnGap && listNode?.lastChild) {
        listNode.lastChild.style.marginRight = listColumnGap;
        isHandledGapInLoop.current = true;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const revertEndingLoopGap = () => {
    if (isHandledGapInLoop.current && listNode?.lastChild?.style?.marginRight) {
      listNode.lastChild.style.marginRight = null;
      isHandledGapInLoop.current = false;
    }
  };

  useEffect(() => {
    if (emblaApi && loop && hasEndingLoopGap && hasItemsToScroll) {
      applyEndingLoopGap();
      emblaApi.reInit();
      emblaApi.on('reInit', applyEndingLoopGap);
    }

    return () => {
      revertEndingLoopGap();
      emblaApi?.off('reInit', applyEndingLoopGap);
    };
  }, [emblaApi, listNode, loop, hasEndingLoopGap, hasItemsToScroll]);
};
